"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LongDateFormat = exports.ShortDateFormat = exports.getNumberOfDaysBetweenDates = exports.DateWithAddedMinutes = exports.GetStartOfTheWeek = exports.GetStartOfHour = exports.GetStartOfDay = exports.TodayAdMidnight = exports.isSameDay = exports.DateToMidnight = exports.DateComparer = exports.ToWeekDayLetter = exports.ToMonthString = exports.ToWeekDayString = exports.ToDateTimeString = exports.ToTimeString = exports.ToShortDateString = exports.ToDateString = exports.DateDisplayFormat = void 0;
// tslint:disable-next-line:no-import-side-effect
require("dayjs/locale/he");
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(customParseFormat_1.default);
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const IL_TIMEZONE = "Asia/Jerusalem";
dayjs_1.default.tz.setDefault(IL_TIMEZONE);
exports.DateDisplayFormat = "DD/MM/YYYY";
function ToDateString(date, format) {
    return (0, dayjs_1.default)(date, format).tz().format(exports.DateDisplayFormat);
}
exports.ToDateString = ToDateString;
function ToShortDateString(date, format) {
    return (0, dayjs_1.default)(date, format).tz().format("DD/MM");
}
exports.ToShortDateString = ToShortDateString;
function ToTimeString(date) {
    return (0, dayjs_1.default)(date).tz(IL_TIMEZONE).format("HH:mm");
}
exports.ToTimeString = ToTimeString;
// TODO yaron add tests
function ToDateTimeString(date) {
    return (0, dayjs_1.default)(date).tz(IL_TIMEZONE).locale("he").format("dddd DD/MM, HH:mm");
}
exports.ToDateTimeString = ToDateTimeString;
function ToWeekDayString(date, format) {
    return `יום ${(0, dayjs_1.default)(date, format).locale("he").format("dddd")}`;
}
exports.ToWeekDayString = ToWeekDayString;
function ToMonthString(date, short) {
    const format = short ? "MMM" : "MMMM";
    let res = (0, dayjs_1.default)(date).locale("he").format(format);
    if (short) {
        res += "'";
    }
    return res;
}
exports.ToMonthString = ToMonthString;
function ToWeekDayLetter(date) {
    return (0, dayjs_1.default)(date).locale("he").format("dd").substring(0, 1);
}
exports.ToWeekDayLetter = ToWeekDayLetter;
function DateComparer(date1, date2) {
    return date1.getTime() - date2.getTime();
}
exports.DateComparer = DateComparer;
function DateToMidnight(date) {
    const midnight = date;
    midnight.setHours(0, 0, 0, 0);
    return midnight;
}
exports.DateToMidnight = DateToMidnight;
function isSameDay(date1, date2) {
    return DateToMidnight(date1).getTime() === DateToMidnight(date2).getTime();
}
exports.isSameDay = isSameDay;
function TodayAdMidnight() {
    const midnight = new Date();
    midnight.setHours(0, 0, 0, 0);
    return midnight;
}
exports.TodayAdMidnight = TodayAdMidnight;
function GetStartOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
}
exports.GetStartOfDay = GetStartOfDay;
function GetStartOfHour(date) {
    const d = new Date(date);
    d.setMinutes(0, 0, 0);
    return d;
}
exports.GetStartOfHour = GetStartOfHour;
function GetStartOfTheWeek(date) {
    const time = GetStartOfDay(date);
    time.setDate(time.getDate() - time.getDay());
    return time;
}
exports.GetStartOfTheWeek = GetStartOfTheWeek;
function DateWithAddedMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}
exports.DateWithAddedMinutes = DateWithAddedMinutes;
function getNumberOfDaysBetweenDates(start, end) {
    const date1 = new Date(start);
    const date2 = new Date(end);
    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;
    // Calculating the time difference between two dates
    const diffInTime = date1.getTime() - date2.getTime();
    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);
    return Math.abs(diffInDays);
}
exports.getNumberOfDaysBetweenDates = getNumberOfDaysBetweenDates;
exports.ShortDateFormat = {
    weekday: "short",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
};
exports.LongDateFormat = {
    weekday: "long",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
};
